import { endOfMonth, format, startOfMonth } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'
import { uk } from 'date-fns/locale'

const DEFAULT_TZ = 'Europe/Kyiv'

function adjustToTz(date: Date, tz: string): Date {
  return toZonedTime(date, tz)
}

export function formatDate(date: Date, tz: string = DEFAULT_TZ): string {
  return format(adjustToTz(date, tz), 'dd.MM.yyyy HH:mm', { locale: uk })
}

export function formatDateOnly(date: Date, tz: string = DEFAULT_TZ): string {
  return format(adjustToTz(date, tz), 'dd.MM.yyyy', { locale: uk })
}

export function formatTimeOnly(date: Date, tz: string = DEFAULT_TZ): string {
  return format(adjustToTz(date, tz), 'HH:mm', { locale: uk })
}

const ISO_DAY = 'yyyy-MM-dd'

/**
 * Today's calendar date in Kyiv as `YYYY-MM-DD` — the value for date inputs
 * and API date fields. `toISOString()` gives the UTC day, which is still
 * yesterday for the first two-three hours of a Kyiv day.
 */
export function todayKyivIso(now: Date = new Date()): string {
  return format(adjustToTz(now, DEFAULT_TZ), ISO_DAY)
}

/** First and last day of the current Kyiv month, as `YYYY-MM-DD`. */
export function monthBoundsKyivIso(now: Date = new Date()): { from: string; to: string } {
  const zoned = adjustToTz(now, DEFAULT_TZ)
  return { from: format(startOfMonth(zoned), ISO_DAY), to: format(endOfMonth(zoned), ISO_DAY) }
}
